<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsSection'];
    count?: number;
}>()

const { backgroundStyles } = useCmsBackgroundStyles(props.content)

const mainBlocks = computed(() => {
    return props.content.blocks.filter((block) => block.sectionPosition === 'main')
})

const sidebarBlocks = computed(() => {
    return props.content.blocks.filter((block) => block.sectionPosition === 'sidebar')
})

const isHeaderOrFooter = computed(() => {
    return props.content.blocks.some((block) => block.type === 'a4g_header' || block.type === 'a4g_footer')
})
</script>

<template>
    <section
        class="cms-section"
        :class="{
            [content.cssClass as string]: content.cssClass,
            'container m-auto px-2 md:px-6': content.sizingMode === 'boxed',
            'w-full': content.sizingMode === 'full_width',
            'block': content.visibility?.mobile,
            'hidden': !content.visibility?.mobile,
            'md:block': content.visibility?.tablet,
            'md:hidden': !content.visibility?.tablet,
            'xl:block': content.visibility?.desktop,
            'xl:hidden': !content.visibility?.desktop
        }"
        :style="backgroundStyles"
    >
        <div :class="{ 'max-w-screen-3xl m-auto px-2 md:px-6': content.sizingMode === 'full_width' && !isHeaderOrFooter }">
            <div class="grid grid-cols-12 gap-6" :class="{'md:-mr-4 md:-ml-4 md:px-4': !isHeaderOrFooter}">
                <aside
                    v-if="content.type === 'sidebar'"
                    :class="{ 'col-span-12': content.mobileBehavior === 'wrap','hidden': content.mobileBehavior === 'hidden' }"
                    class="md:flex md:flex-col md:gap-4 md:col-span-2"
                >
                    <StructureBlock 
                        v-for="(sidebarBlock) in sidebarBlocks" 
                        :key="sidebarBlock.id" 
                        :content="sidebarBlock" 
                        :count="count" 
                    />
                </aside>
                <div :class="{ 'md:col-span-10': content.type === 'sidebar' }" class="flex flex-col gap-4 col-span-12">
                    <StructureBlock 
                        v-for="(mainBlock) in mainBlocks" 
                        :key="mainBlock.id" 
                        :content="mainBlock" 
                        :count="count" 
                    />
                </div>
            </div>
        </div>
    </section>
</template>
